module.exports = __webpack_public_path__ + "static/media/v-down-inactive.03c9ecf7.svg";